import React from 'react';

const ButtonSearch = () => {
    return (
        <button type="submit" className="btn btn-sm btn-before-dot btn-link border-0 p-0 min-w-auto text-uppercase">Search</button>
    );
};

export default ButtonSearch;
